<template>
<div>

  <el-row>
    <el-col :span="17">
  <!-- 面包屑导航区域-->
  <el-breadcrumb separator-class="el-icon-arrow-right">
    <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
    <el-breadcrumb-item>Opportunity</el-breadcrumb-item>
    <el-breadcrumb-item>Project Status</el-breadcrumb-item>
  </el-breadcrumb>
</el-col>
  <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
    Updating Time: {{ this.updateTime }}
    </el-col> -->
  </el-row>
  <!--卡片视图区域-->

  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">

      <el-row>
        <el-col :span = "7">
      <el-form-item label="Brand:" label-width="90px">
        <el-select v-model="formInline.brands" multiple collapse-tags
              style="margin-left: 0px;"  filterable
              placeholder="please choose">
            <el-option
            v-for="item in brandList"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      </el-col>
      <el-col :span = "7">
        <el-form-item label="Item:" label-width="100px">
          <el-input v-model="formInline.item" placeholder="Item" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "10">
        <el-form-item label="Due Date:" label-width="90px">
        <el-date-picker
              v-model="formInline.dueDate"  value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="Start Date"
              end-placeholder="End Date">
            </el-date-picker>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row>
      <el-col :span = "7">
        <el-form-item label="Status:" label-width="90px">
            <el-select v-model="formInline.status" multiple collapse-tags clearable
                  style="margin-left: 0px;"
                  placeholder="please choose">
                <el-option
                v-for="item in statusList"
                :key="item.code"
                :label="item.code"
                :value="item.code">
                <span style="float: left; width: 30px;">{{ item.code }}</span>
                <span style="margin-left: 100px; color: #8492a6; font-size: 13px; display:inline-block;width: 150px;">{{ item.description }}</span>
              </el-option>
            </el-select>
            <!-- <el-select v-model="formInline.status" multiple collapse-tags
                  style="margin-left: 0px;"
                  placeholder="please choose">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                <span style="float: left">{{ item.label }}</span>
                <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.value }}</span>
              </el-option>
            </el-select> -->
        </el-form-item>
      </el-col>
      <el-col :span = "7">
        <el-form-item label="Project Id:" label-width="100px">
          <el-input v-model="formInline.projectId" placeholder="Project Id" clearable></el-input>
        </el-form-item>
      </el-col>
      <el-col :span = "10">
        <el-form-item label="Updated:" label-width="90px">
        <el-date-picker
              v-model="formInline.updated"  value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="-"
              start-placeholder="Start Date"
              end-placeholder="End Date">
            </el-date-picker>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span = "7">
          <el-form-item label="To Do By:" label-width="90px">
            <el-input v-model="formInline.todoby" placeholder="To Do By" clearable></el-input>
            <!-- <el-select v-model="formInline.todoby" clearable
                  style="margin-left: 0px;"
                  placeholder="please choose">
                <el-option
                v-for="item in this.salesRepList"
                :key="item.salesRep"
                :label="item.salesRep"
                :value="item.salesRep">
                <span style="float: left">{{ item.salesRep }}</span>
                <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.lastName }}</span>
              </el-option>
            </el-select> -->
          </el-form-item>
          </el-col>
          <el-col :span = "7">
            <el-form-item label="Description:"  label-width="100px">
              <el-input v-model="formInline.descr" placeholder="Description" clearable></el-input>
            </el-form-item>
          </el-col>
          <div v-if="this.userName.toUpperCase()==='J3P' || this.userName.toUpperCase()==='IP'">
      <el-col :span = "10">
        <el-form-item label="Supplier:"  label-width="90px">
            <el-input v-model="formInline.supplier" placeholder="Supplier" clearable></el-input>
          </el-form-item>
        </el-col>
        </div>
        <div v-else>
          <el-col :span = "10">
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportToExcel">Excel</el-button>
          </el-form-item>
          </el-col>
        </div>
        </el-row>
        <div v-if="this.userName.toUpperCase()==='J3P' || this.userName.toUpperCase()==='IP'">
        <el-row>
          <el-col>
          <el-form-item style="margin-left: 450px;">
            <el-button type="primary" @click="onSubmit">Search</el-button>
            <el-button type="primary" @click="exportToExcel">Excel</el-button>
          </el-form-item>
          </el-col>
        </el-row>
        </div>
      <!-- <el-form-item>
        <el-button type="primary" @click="onSubmit">Search</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="exportToExcel">Excel</el-button>
      </el-form-item>
      </el-col>
      </el-row> -->
    </el-form>
      <!-- Schedule 列表区域 -->
      <el-table :data="projectList" border stripe style="width: 100%">

        <el-table-column type="expand" fixed>
              <template slot-scope="props">
                <el-form inline class="demo-table-expand" border>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item label="Line" :show-overflow-tooltip="true">
                        {{ props.row.line }}
                      </el-form-item>
                    </el-col>
                    <el-col :span="15">
                    <el-form-item label="Updated">
                                        <span>{{ dateFormat1(props.row.updated) }}</span>
                                      </el-form-item>
                                        </el-col>
                    <!-- <el-col :span="15"><el-form-item label="ETD">
                      {{ dateFormat1(props.row.etd) }}
                     </el-form-item></el-col> -->
                  </el-row>
                  <el-row>
                   <el-col :span="6"><el-form-item label="Product" prop="product">
                    <span>{{ props.row.product }}</span>
                  </el-form-item>
                   </el-col>
                   <el-col :span="6"><el-form-item label="PI Confirmed Date" prop="piConfirmedDate">
                     <span>{{ dateFormat1(props.row.piConfirmedDate) }}</span>
                   </el-form-item>
                    </el-col>
                   <!-- <el-col :span="15">
                   <el-form-item label="Updated">
                                       <span>{{ dateFormat1(props.row.updated) }}</span>
                                     </el-form-item>
                                       </el-col> -->
                  </el-row>
                </el-form>
              </template>
            </el-table-column>
        <el-table-column type="index" fixed label="#"></el-table-column>
            <el-table-column
              prop="brand"    fixed  sortable
              label="Brand" :show-overflow-tooltip="true"
              width="80">
            </el-table-column>
            <el-table-column
              prop="descr"
              label="Description" :show-overflow-tooltip="true"
              width="120">
            </el-table-column>

            <el-table-column
              prop="item"
              label="Item"     sortable
              width="79">
            </el-table-column>

            <el-table-column
              prop="cap"     sortable
              label="Cap. (ml)" :show-overflow-tooltip="true"
              width="110">
            </el-table-column>

            <el-table-column
              prop="material"
              label="Material"     sortable
              width="100">
            </el-table-column>

            <el-table-column :sort-orders="['descending', 'ascending']"
              prop="deco"     sortable
              label="Deco" :show-overflow-tooltip="true"
              width="90">
            </el-table-column>

            <el-table-column
              prop="done"
              label="Done" :show-overflow-tooltip="true"
              width="100">
            </el-table-column>

            <el-table-column
              prop="status"     sortable
              label="Status" :show-overflow-tooltip="true"
              width="90">
            </el-table-column>

            <el-table-column
              prop="next"
              label="Next"  :show-overflow-tooltip="true"
              width="120">
            </el-table-column>

            <el-table-column
              prop="project_id"
              label="Project ID"     sortable
              width="120">
            </el-table-column>

            <el-table-column
              prop="etd"     sortable      :sort-method="sortByEtd"
              label="ETD" :formatter="dateFormat"
              width="100">
            </el-table-column>

            <el-table-column
              prop="todoby"
              label="ToDo by"     sortable
              width="100">
            </el-table-column>
            <el-table-column
              prop="org"
              label="Organization"     sortable
              width="130">
            </el-table-column>

            <el-table-column
              prop="dueDate"     sortable      :sort-method="sortBydueDate"
              label="Due date" :formatter="dateFormat"
              width="100">
            </el-table-column>

            <el-table-column
              prop="warning"
              label="Timeline"
              width="100">
            </el-table-column>

            <!-- <el-table-column
              prop="piConfirmedDate"              sortable      :sort-method="sortByPiConfirmedDate"
              label="PI Confirmed Date"         :formatter="dateFormat"
              width="100">
            </el-table-column> -->

            <el-table-column
            v-if="this.userName.toUpperCase()==='IP' || this.userName.toUpperCase()==='J3P'
            || this.brandParam.userType==='2'"
              prop="supplier"
              label="Supplier"     sortable
              width="100">
            </el-table-column>
            <el-table-column
              prop="moldNbr"
              label="Number of Mold"
              width="120">
            </el-table-column>
            <el-table-column
              prop="priority"
              label="Priority"
              width="90">
            </el-table-column>
            <el-table-column
              prop="leadTime"
              label="Lead Time"
              width="90">
            </el-table-column>

            <el-table-column
              prop="projectLeader"
              label="Project Leader"
              width="120">
            </el-table-column>

            <el-table-column
              prop="type"
              label="Project Type"
              width="110">
            </el-table-column>

          </el-table>

          <!-- 分页区域-->
           <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="formInline.page"
                :page-sizes="[10, 20, 30, 50, 100, total]"
                :page-size="formInline.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
  </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        brands: [],
        descr: '',
        item: '',
        projectId: '',
        updated: '',
        status: [],
        todoby: '',
        dueDate: '',
        supplier: '',
        token: '',
        page: 1,
        rows: 100
      },
      projectList: [],
      userName: '',
      updatedStart: '',
      updatedEnd: '',
      dueDateStart: '',
      dueDateEnd: '',
      updateTime: '',
      total: 0,
      brandList: [],
      statusList: [],
      // options: [{
      //   value: 'DEV',
      //   label: 'Development',
      //   description: 'Development'
      // }, {
      //   value: 'HLD',
      //   label: 'On Hold',
      //   description: 'On Hold'
      // }, {
      //   value: 'LHK',
      //   label: 'Loading Hong Kong',
      //   description: 'Loading Hong Kong'
      // }, {
      //   value: 'LSH',
      //   label: 'Loading Shanghai',
      //   description: 'Loading Shanghai'
      // }, {
      //   value: 'LXI',
      //   label: 'Loading Xiamen',
      //   description: 'Loading Xiamen'
      // }, {
      //   value: 'LYA',
      //   label: 'Loading Yantian',
      //   description: 'Loading Yantian'
      // }, {
      //   value: 'NEW',
      //   label: 'New Order',
      //   description: 'New Order'
      // }, {
      //   value: 'OKC',
      //   label: 'Confirmed to Close on arrival',
      //   description: 'Confirmed to Close on arrival'
      // }, {
      //   value: 'OLO',
      //   label: 'On Line QC Pass',
      //   description: 'On Line QC Pass'
      // }, {
      //   value: 'ONG',
      //   label: 'On Going Production',
      //   description: 'On Going Production'
      // }, {
      //   value: 'PND',
      //   label: 'Pending for Approval',
      //   description: 'Pending for Approval'
      // }, {
      //   value: 'PNO',
      //   label: 'Produce with Next Order',
      //   description: 'Produce with Next Order'
      // }, {
      //   value: 'REJ',
      //   label: 'Reject',
      //   description: 'Reject'
      // }, {
      //   value: 'RHK',
      //   label: 'Ready Hong Kong',
      //   description: 'Ready Hong Kong'
      // }, {
      //   value: 'RSH',
      //   label: ' Ready Shanghai',
      //   description: ' Ready Shanghai'
      // }, {
      //   value: 'RTC',
      //   label: 'Request to Close',
      //   description: 'Request to Close'
      // }, {
      //   value: 'RXI',
      //   label: 'Ready Xiamen',
      //   description: 'Ready Xiamen'
      // }, {
      //   value: 'RYA',
      //   label: 'Ready Yantian',
      //   description: 'Ready Yantian'
      // }, {
      //   value: 'SFR',
      //   label: 'Shipment ready from France',
      //   description: 'Shipment ready from France'
      // }, {
      //   value: 'SME',
      //   label: 'Shipment ready from Mexico',
      //   description: 'Shipment ready from Mexico'
      // }, {
      //   value: 'TLB',
      //   label: 'Ready for Transfer to LB',
      //   description: 'Ready for Transfer to LB'
      // }, {
      //   value: 'TYF',
      //   label: 'Ready for Transfer to Yufan',
      //   description: 'Ready for Transfer to Yufan'
      // }, {
      //   value: 'WFC',
      //   label: 'Waiting for confirmation',
      //   description: 'Waiting for confirmation'
      // }
      // ],
      salesRepList: [],
      brandParam: {
        userName: '',
        userType: ''
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    this.getProjects()
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
    this.getSalesReps()
    this.getStatusList()
  },
  methods: {
    async getBrands () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandList = await res.brands
    },
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getProjects()
    },
    exportToExcel () {
      /* 表示在当前页面打开新地址 51.68.206.7https://www.myirequest.com */
      window.open('https://www.myirequest.com:8081/prospect/exportProject?token=' + encodeURIComponent(this.formInline.token) +
      '&brand=' + this.formInline.brands + '&descr=' + this.formInline.descr + '&projectId=' + this.formInline.projectId +
      '&item=' + this.formInline.item + '&updated=' + this.formInline.updated +
      '&status=' + this.formInline.status + '&todoby=' + this.formInline.todoby +
      '&supplier=' + this.formInline.supplier + '&dueDate=' + this.formInline.dueDate, '_parent')
      // window.open('http://localhost:8081/show/exportProject?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&descr=' + this.formInline.descr + '&item=' + this.formInline.item, '_parent')
    },
    async getStatusList () {
      const { data: res6 } = await this.$http.get('/customer/getStatusList')
      this.statusList = await res6.statusList
    },
    async getProjects () {
      var brandsStr = ''
      var statusStr = ''
      this.updatedStart = ''
      this.updatedEnd = ''
      this.dueDateStart = ''
      this.dueDateEnd = ''

      if (this.formInline.status && this.formInline.status.length) {
        this.formInline.status = [...this.formInline.status].join(',')
        statusStr = this.formInline.status
      }

      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }

      if (this.formInline.updated) {
        if (this.formInline.updated.length) {
          this.updatedStart = this.formInline.updated[0]
          this.updatedEnd = this.formInline.updated[1]
          this.formInline.updated = [...this.formInline.updated].join(',')
        }
      }
      if (this.formInline.dueDate) {
        if (this.formInline.dueDate.length) {
          this.dueDateStart = this.formInline.dueDate[0]
          this.dueDateEnd = this.formInline.dueDate[1]
          this.formInline.dueDate = [...this.formInline.dueDate].join(',')
        }
      }

      const { data: res } = await this.$http.get('/prospect/projectList', { params: this.formInline })
      this.projectList = res.rows
      this.total = res.total
      if (res.rows && this.projectList[0]) {
        this.updateTime = this.projectList[0].createTime
      }
      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      if (statusStr !== '') {
        await this.$set(this.formInline, 'status', statusStr.split(','))
      }

      await this.$set(this.formInline, 'updated', [this.updatedStart, this.updatedEnd])
      await this.$set(this.formInline, 'dueDate', [this.dueDateStart, this.dueDateEnd])
    },
    async getSalesReps () {
      const { data: res } = await this.$http.get('/customer/getSalesRepList')
      this.salesRepList = await res.salesRepList
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      if (daterc === null || daterc === '' || daterc === '' || daterc === '1753/01/01 00:00:00' ||
      daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getProjects()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getProjects()
    },
    getMonth (month) {
      var monthLetter
      switch (month) {
        case '01':
          monthLetter = 'Jan'
          break
        case '02':
          monthLetter = 'Feb'
          break
        case '03':
          monthLetter = 'Mar'
          break
        case '04':
          monthLetter = 'Apr'
          break
        case '05':
          monthLetter = 'May'
          break
        case '06':
          monthLetter = 'Jun'
          break
        case '07':
          monthLetter = 'Jul'
          break
        case '08':
          monthLetter = 'Aug'
          break
        case '09':
          monthLetter = 'Sep'
          break
        case 10:
          monthLetter = 'Oct'
          break
        case 11:
          monthLetter = 'Nov'
          break
        case 12:
          monthLetter = 'Dec'
          break
      }
      return monthLetter
    },
    dateFormat1 (daterc) {
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === '1753-01-01 00:00:00') {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    sortBydueDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.dueDate).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.dueDate).getTime() / 1000)
      return val1 - val2
    },
    sortByEtd (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.etd).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.etd).getTime() / 1000)
      return val1 - val2
    },
    sortByPiConfirmedDate (obj1, obj2) {
      var val1 = Math.floor(new Date(obj1.piConfirmedDate).getTime() / 1000)
      var val2 = Math.floor(new Date(obj2.piConfirmedDate).getTime() / 1000)
      return val1 - val2
    }
    // dateFormat (value) {
    //   if (value === null || value === '') {
    //     return ''
    //   }
    //   var date = new Date(value) // long转换成date
    //   var year = date.getFullYear().toString()
    //   var month = (date.getMonth() + 1)
    //   var day = date.getDate().toString()
    //   if (month < 10) {
    //     month = '0' + month
    //   }
    //   if (day < 10) {
    //     day = '0' + day
    //   }
    //   return year + '/' + month + '/' + day
    // }
  }
}
</script>

<style>
</style>
